import * as React from 'react';

import Unplugged140 from './Unplugged140';

export const unplugged140 = () => <Unplugged140 />;

export default {
    title: 'Illustration/Unplugged140',
    component: Unplugged140,
    parameters: {
        notes: "`import Unplugged140 from 'box-ui-elements/es/illustration/Unplugged140';`",
    },
};
